import { Auth, Hub } from "aws-amplify";
import { useEffect, useState } from "react";

function useUser() {
  const [loading, setLoading] = useState(true);

  const [user, setUser] = useState<any | undefined>(undefined);
  const {
    signInUserSession: {
      // @ts-ignore
      accessToken: { payload: { "cognito:groups": groups } } = {},
    } = {},
  } = user || {
    signInUserSession: {
      accessToken: { payload: { "cognito:groups": [] } },
    },
  };
  useEffect(() => {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        setUser(user);
      })
      .catch((error) => {
        console.log("Not authenticated");
        setUser(undefined);
      })
      .finally(() => setLoading(false));
  }, []);
  useEffect(() => {
    Hub.listen("auth", (data) => {
      switch (data.payload.event) {
        case "signIn":
          setUser(data.payload.data);
          setLoading(false);
          break;
        case "signOut":
          setLoading(false);
          setUser(undefined);
          break;
        default:
          break;
      }
    });
  }, []);

  return {
    loading,
    user,
    groups: groups || [],
  };
}

export default useUser;
